/* UCAN design system — small progressive-enhancement helpers.
   Scroll reveal, YouTube click-to-load facades, accordions, thumbnail fallback. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealAll() {
    document.querySelectorAll('.uc-reveal').forEach(function (el) {
      el.classList.add('is-in');
    });
  }

  /* ---------- Scroll reveal ---------- */
  function initReveal(root) {
    var items = (root || document).querySelectorAll('.uc-reveal:not([data-uc-revealed])');
    if (!items.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (el) {
        el.classList.add('is-in');
        el.setAttribute('data-uc-revealed', '');
      });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          var delay = parseInt(el.getAttribute('data-uc-delay') || '0', 10);
          setTimeout(function () {
            el.classList.add('is-in');
          }, delay);
          io.unobserve(el);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    items.forEach(function (el) {
      el.setAttribute('data-uc-revealed', '');
      io.observe(el);
    });
  }

  /* ---------- Thumbnail fallback ----------
     YouTube answers with a tiny grey placeholder (120x90) when a video has no
     public thumbnail. Swap those for the UCAN placeholder rather than showing
     a blurred grey box. */
  function initThumbs(root) {
    var imgs = (root || document).querySelectorAll('.uc-video img:not([data-uc-checked])');
    imgs.forEach(function (img) {
      img.setAttribute('data-uc-checked', '');
      var check = function () {
        if (img.naturalWidth && img.naturalWidth <= 160 && window.UCAN_PLACEHOLDER) {
          img.src = window.UCAN_PLACEHOLDER;
          img.style.objectFit = 'cover';
        }
      };
      if (img.complete) check();
      else img.addEventListener('load', check, { once: true });
    });
  }

  /* ---------- YouTube facade ---------- */
  function initVideos(root) {
    var buttons = (root || document).querySelectorAll('.uc-video__btn:not([data-uc-bound])');
    buttons.forEach(function (btn) {
      btn.setAttribute('data-uc-bound', '');
      btn.addEventListener('click', function () {
        var wrap = btn.closest('.uc-video');
        if (!wrap) return;
        var id = wrap.getAttribute('data-video-id');
        if (!id) return;
        var start = wrap.getAttribute('data-video-start');
        var src =
          'https://www.youtube-nocookie.com/embed/' +
          encodeURIComponent(id) +
          '?autoplay=1&rel=0&playsinline=1' +
          (start ? '&start=' + encodeURIComponent(start) : '');
        var iframe = document.createElement('iframe');
        iframe.setAttribute('src', src);
        iframe.setAttribute('title', btn.getAttribute('aria-label') || 'Video');
        iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
        iframe.setAttribute('allowfullscreen', '');
        iframe.setAttribute('loading', 'lazy');
        wrap.innerHTML = '';
        wrap.appendChild(iframe);
      });
    });
  }

  /* ---------- Accordion: keep one open per group when requested ---------- */
  function initAccordions(root) {
    var groups = (root || document).querySelectorAll('[data-uc-accordion="single"]:not([data-uc-bound])');
    groups.forEach(function (group) {
      group.setAttribute('data-uc-bound', '');
      group.addEventListener('toggle', function (event) {
        var target = event.target;
        if (!(target instanceof HTMLDetailsElement) || !target.open) return;
        group.querySelectorAll('details[open]').forEach(function (other) {
          if (other !== target) other.open = false;
        });
      }, true);
    });
  }

  function initAll(root) {
    initReveal(root);
    initThumbs(root);
    initVideos(root);
    initAccordions(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  /* Safety net: whatever happens, nothing stays invisible. */
  setTimeout(revealAll, 3000);
  window.addEventListener('load', function () {
    setTimeout(revealAll, 1500);
    initThumbs(document);
  });

  /* Re-init when the theme editor re-renders a section */
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();